/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_ExploreInputs */

const en_projects_explore = /** @type {(inputs: Projects_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore the concept`)
};

const lv_projects_explore = /** @type {(inputs: Projects_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt konceptu`)
};

/**
* | output |
* | --- |
* | "Explore the concept" |
*
* @param {Projects_ExploreInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_explore = /** @type {((inputs?: Projects_ExploreInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_ExploreInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_explore(inputs)
	return en_projects_explore(inputs)
});